import React from "react";

import { faXmark } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defineMessage, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./DismissButton.module.scss";

const dismissMessage = defineMessage({
  id: "savedLocations.namingCard.dismissButton.label",
  defaultMessage: "Dismiss",
  description: "Label of the button that closes the card shown after saving a location",
});

export interface DismissButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

const DismissButton = ({ disabled, onClick }: DismissButtonProps) => {
  const intl = useIntl();

  return (
    <Button
      aria-label={intl.formatMessage(dismissMessage)}
      className={styles.dismiss}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faXmark} />}
      iconOnly
      onClick={() => onClick()}
      type="text"
    />
  );
};

export default DismissButton;
